import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "My new 5K monitor – LG UltraFine 5K 😱",
  "description": "",
  "published": "2017-12-11T00:00:00.000Z",
  "redirect_from": ["/blog/new-5k-monitor-lg-ultrafine-5k/swizec/7955"],
  "categories": "Business, Freelancing, Side Projects, Writing",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`My code has never looked so beautiful!`}</p>
    <lite-youtube {...{
      "videoid": "3goTf93srNM",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`Monitor reviews are a very visual affair. Watch the video 👆`}</p>
    <p>{`Got my `}<a parentName="p" {...{
        "href": "http://amzn.to/2C3SlsD"
      }}>{`LG UltraFine 5K 27" from Amazon`}</a>{`. Mine was a refurb, so I saved about $500 from full price. Your luck may vary.`}</p>
    <p>{`Here's a quick rundown for the impatient 👇`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`New office setup with the 5K monitor 👌`}<br parentName="p"></br><br parentName="p"></br>{`On cable to rule them all `}<a parentName="p" {...{
          "href": "https://t.co/uJcVTfUpry"
        }}>{`pic.twitter.com/uJcVTfUpry`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/940112462447198208"
      }}>{`December 11, 2017`}</a></blockquote>
    <p><strong parentName="p">{`Pros`}</strong></p>
    <ul>
      <li parentName="ul">{`gorgeous picture`}</li>
      <li parentName="ul"><strong parentName="li">{`so many`}</strong>{` pixels 5120x2880`}</li>
      <li parentName="ul">{`seriously, my code looks like it's printed on paper 😍`}</li>
      <li parentName="ul">{`one cable to rule them all (same cable charges your laptop and connects everything)`}</li>
      <li parentName="ul">{`3 USB-C ports, works as a hub`}</li>
      <li parentName="ul">{`USB-C connection should have enough bandwidth for a lot of peripherals`}</li>
      <li parentName="ul"><em parentName="li">{`amazing`}</em>{` built-in speakers, no more muffled bassy sound`}</li>
      <li parentName="ul">{`okay webcam`}</li>
      <li parentName="ul">{`adjustable height and 2-directional tilt`}</li>
      <li parentName="ul">{`light yet sturdy`}</li>
      <li parentName="ul">{`design looks 👌`}</li>
    </ul>
    <p><strong parentName="p">{`Cons`}</strong></p>
    <ul>
      <li parentName="ul">{`USB-C only, you need to buy a hub (I got one with USB + ethernet + SDcards, duct-taped it to the back)`}</li>
      <li parentName="ul">{`doesn't seem to adjust brightness to ambient light`}</li>
      <li parentName="ul">{`13" macbook pro from 2017 struggles a bit`}</li>
      <li parentName="ul">{`15" macbook pro with top spec GPU can't run games in full 5K`}</li>
      <li parentName="ul">{`too many pixels, gotta be careful when taking screenshots (must resize, big files)`}</li>
      <li parentName="ul">{`super expensive`}</li>
      <li parentName="ul">{`completely unnecessary for most daily tasks`}</li>
      <li parentName="ul">{`MacOS sometimes does wonky things with USB-C connections like crash your computer if you plug and unplug impatiently`}</li>
      <li parentName="ul">{`doesn't give you more screen real estate room than a normal 27" monitor (not at "native" resolution at least)`}</li>
    </ul>
    <p>{`The reason I went for 5K instead of just 4K are the Amazon reviews that say `}<em parentName="p">{`"Don't get a 27" 4K, MacOS does funny things"`}</em>{`. Something about not being able to run at native resolution so you either get suuuuuper tiny visuals, or everything's blurry.`}</p>
    <p>{`Your only options are a 24" 4K or a 27" 5K. I hear 32" 4K works great too, but my desk isn't big enough.`}</p>
    <p><strong parentName="p">{`Verdict`}</strong></p>
    <p>{`2017 is still too early for 5K. There are only 2 monitors on the market, `}<a parentName="p" {...{
        "href": "http://amzn.to/2C3SlsD"
      }}>{`the LG`}</a>{` and the Dell, and they're both expensive as hell. Laptops have trouble driving the full resolution for anything interesting, and you don't get more real estate than normal.`}</p>
    <p>{`It's a fancy toy, looks great, your eyes will love you. But if you have a working monitor, I'd wait a few more years for 5K to become the norm.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      